module.exports = __webpack_public_path__ + "static/media/4421.b8864f4e.jpg";